<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'申请担保审核'}]" :title="'申请担保审核'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待审核" name="1" v-if="authorities.indexOf('sys:permission:background:guarantee:apply:unAudit')!==-1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2" v-if="authorities.indexOf('sys:permission:background:guarantee:apply:audit')!==-1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果</span>
                        <el-select v-model="sendInfoOne.checkStatus" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                       <el-date-picker
                           size="small"
                           v-model="dateS"
                           format="yyyy-MM-dd"
                       	value-format="yyyy-MM-dd HH:mm:ss"
                       	type="datetimerange" 
                       	:default-time="['24:00:00','23:59:59']"
                           range-separator="至"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                       </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==='1'"
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="担保公司名称">
                    <template slot-scope="scope">
                        <div v-if="scope.row.vouchName!= '经开区中小担'" class="tableName ellipsis" @click="viewDetails(scope.row)">{{scope.row.vouchName}}</div>
                        <div v-else class="ellipsis">{{scope.row.vouchName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:guarantee:apply:unAudit:button:view')!=-1||authorities.indexOf('sys:permission:background:guarantee:apply:unAudit:button:audit')!=-1"
                        size="small" @click="audit(scope.row)"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button 
						v-if="authorities.indexOf('sys:permission:background:guarantee:apply:unAudit:button:view')!=-1"
                        size="small" type="primary" class="super" plain @click="check(scope.row)">查看</el-button>
                        <el-button 
						v-if="authorities.indexOf('sys:permission:background:guarantee:apply:unAudit:button:audit')!=-1"
                        size="small" type="primary" class="super" plain  @click="audit(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                ref="multipleTable"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="担保公司名称">
                    <template slot-scope="scope">
                        <div v-if="scope.row.vouchName!= '经开区中小担'" class="tableName" @click="viewDetails(scope.row)">{{scope.row.vouchName}}</div>
                        <div v-else>{{scope.row.vouchName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    width="100"
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="审核账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="审核时间">
                </el-table-column>
                <el-table-column
                    prop="checkStatusValue"
                    show-overflow-tooltip
                    
                    width="150"
                    label="审核结果">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100"
					v-if="authorities.indexOf('sys:permission:background:information:release:audit:button:view')!=-1"
                    >
                    <template slot-scope="scope">
                        <el-button 
                        size="small" type="primary" class="super" plain @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :totalSize="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看表格详情 -->
            <el-dialog
                title="担保公司信息"
                :visible.sync="dialogDetail"
                width="50%">
                <div class="basic">
                    <div class="child">
                        <div class="name">担保公司名称：</div>
                        <div class="content">{{companyInfo.companyName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">LOGO：</div>
                        <div class="content"><img class="logos" :src="companyInfo.logoUrl"></div>
                    </div>
                    <div class="child">
                        <div class="name">公司简介：</div>
                        <div class="content">{{companyInfo.remarks}}</div>
                    </div>
                    <div class="childMulti">
                        <div class="name">担保说明：</div>
                        <ul>
                             <li class="content" 
							 v-for="(i,index) in companyInfo.explanation" 
							 :key="index"
							 >{{i.sort+'.'+i.content}}</li>
                           
                        </ul>
                    </div>
                    <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,i) in companyInfo.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                            </li>
                        </ul>
                    </div>
                </div>
            </el-dialog>
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">账号信息</div>
                        <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{detailInfo.user.userName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detailInfo.user.userTypeName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{detailInfo.user.realName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detailInfo.user.email}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detailInfo.user.contactAddress}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{detailInfo.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfo.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{detailInfo.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.applyRemark}}</div>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detailInfo.createTime}}</div>
                        </div>
                        <div class="child" v-if="ishide">
                            <div class="name">是否同意《信息采集协议》：</div>
                            <div class="content">是</div>
                        </div>
                    </div>
                    <div class="boxChild" v-if="tab==='2'">
                        <div class="basisTitle">审核结果</div>
                        <div class="child">
                            <div class="name">审核结果：</div>
                            <div class="content">{{detailInfo.checkStatusValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detailInfo.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.checkExplanation}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 审核 -->
            <el-dialog
                title="审核"
                :visible.sync="dialogAudit"
                width="28%">
                <div class="forms">
                <div class="child">
                    <div class="name"><span>*</span>审核结果：</div>
                    <el-radio-group v-model="sendInfoTwo.checkStatus">
                            <el-radio :label="item.value" v-for="(item,index) in statusList" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                </div>
                <div class="error" v-if="errors['sendInfoTwo.checkStatus']">错误提示：{{errors['sendInfoTwo.checkStatus']}}</div>
                <div class="childTextarea">
                    <div class="name">说明：</div>
                    <div class="content"><el-input type="textarea" v-model="sendInfoTwo.checkRemark" show-word-limit maxlength="200" style="max-width:100%;"></el-input></div>
                </div>
                <div class="doubleBtn">
                    <el-button size="small" type="primary" @click="submit">确认</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
        </div>
    </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
// import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            ishide:false,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }, {
                value: '4',
                label: '申请人姓名'
            }, {
                value: '5',
                label: '担保公司名称'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                checkStatus:'',//审核结果
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                userName:'',//账号
                name:'',//姓名
                vouchName:'',//担保公司名称
                applicant:'',//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tab:'1',//选项卡
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[{name:'12assssssss'}],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//审核弹出层
            dialogDetail:false,//表格内详情弹出层
            sendInfoTwo:{
                applyId:'',
                checkStatus:null,//审核结果
                checkRemark:'',//说明
            },//审核提交数据
            scopeListArray:[],
            scopeList:[],
            statusList:[],
            totalSize:null,
            companyInfo:{
                companyName:'',
                classifyValue:'',
                logoUrl:'',
                remarks:'',
                explanation:'',
                fileList:''
            },
            detailInfo:{
                user:{
                    userName:'',
                    userTypeName:'',
                    realName:'',
                    email:'',
                    contactAddress:'',
                },
                applicant:'',
                contactPhone:'',
                applyCompany:'',
                applyRemark:'',
                fileList:[],
                createTime:'',
                checkStatusValue:'',
                modifyUserName:'',
                updateTime:'',
                checkExplanation:'',
            }
        }
    },
	mounted(){
      const that = this
	    // 审核结果
	    // getDict('CHECK_STATUS').then(data=>{
	    //     data.CHECK_STATUS.shift()
	    //     that.statusList = data.CHECK_STATUS
	    // })
      that.getReviewResultList()
		
      // 待审核
      if(that.authorities.indexOf('sys:permission:background:guarantee:apply:unAudit')==-1){
        that.tab='2'
      }
      // 待审核 和审核记录存在一个
      if(that.authorities.indexOf('sys:permission:background:guarantee:apply:unAudit')!=-1||that.authorities.indexOf('sys:permission:background:guarantee:apply:audit')!=-1){
        that.getData()
      }
      let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 80 
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 80 
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
	    
	},
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.checkStatus':{
            test:function(){
                if(this.sendInfoTwo.checkStatus){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择审核结果'
        },
    },
    methods:{
      //获取字典 审核状态
            async getReviewResultList () {
                // const {code,data} = await this.$axiosz.get('backstage/sysDict/isShow/CHECK_STATUS')
                const {code,data} = await this.$axiosz.get('backstage/sysDict/auditOption')
                if (code == 200) {
                        this.statusList = data; 
                    }
            },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
          onReset(){
            this.getSelect='';//检索下拉的值
            this.getValue='';//检索输入框的值
            this.dateS=[];//日期
            this.sendInfoOne.currentPage=1;//当前页
            this.sendInfoOne.pageSize=20;//页条数
            this.sendInfoOne.checkStatus='';//审核结果
            this.sendInfoOne.endDate='';//结束时间
            this.sendInfoOne.startDate='';//开始时间
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.vouchName='';//债权产品名称
            this.sendInfoOne.applicant='';//申请人姓名
            this.sendInfoOne.property = null
            this.sendInfoOne.direction = null
            this.totalSize=null;//总页码
            this.getData();
          },
        // 切换选项啦
        changeTab:function(tab){
            this.tab=tab.name;
            this.onReset()
        },
        //查看表格内详情
        viewDetails:function(row){
            if(row.loanId == 0){
                this.$message({
                    type: 'success',
                    message: '没有信息'
                });
            }else{
                // this.$axiosz.get('/backstage/guarantee/details/'+row.loanId).then(res=>{
                //     if(res.code == 200){
                //         this.companyInfo = res.data
                //         this.companyInfo.logoUrl = this.companyInfo.frontPath+this.companyInfo.logoUrl
                //         this.dialogDetail=true;
                //     }else{
                //         this.$message({
                //             type: 'error',
                //             message: res.msg
                //         });
                //     }
                // })
                this.$router.push({path: `/auditsManagement/applicationGuarantee/company/detail/${this.tab}`, query: {id: row.loanId, index: '/auditsManagement/applicationGuarantee'},param:{type:this.tab}})
            }
            
            
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //查看明细
        check:function(row){
            if(row.vouchName == '经开区中小担'){
                this.ishide = true
            }else{
                this.ishide = false
            }
            // this.$axiosc.get('backstage/vouch/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.detailInfo = res.data
            //         this.dialogInfo=true;
            //     }
            // })
            this.$router.push({path: `/auditsManagement/applicationGuarantee/detail/${this.tab}`, query: {id: row.id, index: '/auditsManagement/applicationGuarantee',ishide:this.ishide},param:{type:this.tab}})
            
        },
        //打开审核
        audit:function(row){
            this.sendInfoTwo.applyId = row.id
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/common/applyReview',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '审核成功！',
                        });
                        this.dialogAudit = false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg,
                        });
                    }
                })
            }
        },
        getData(){
            this.loading = true
            if(this.dateS&&this.dateS.length>0){
                 this.sendInfoOne.startDate=this.dateS[0];
                 this.sendInfoOne.endDate=this.dateS[1];
             }else{
                 this.sendInfoOne.startDate='';
                 this.sendInfoOne.endDate='';
             }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.applicant = ''
            this.sendInfoOne.vouchName='';//债权产品名称
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='4'){ //申请人姓名
                this.sendInfoOne.applicant=this.getValue;
            }else if(this.getSelect=='5'){ //担保公司名称
                this.sendInfoOne.vouchName=this.getValue;
            }
            let url='';
            this.scopeList = []
            if(this.tab==='1'){
                url='backstage/vouch/apply/pending/review/list';
            }else{
                url='backstage/vouch/apply/audited/list';
            }
            this.$axiosc.get(url,{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                }else{
                    this.$alert(res.msg)
                }
               
            }).catch(e=>{
              this.loading = false
            })
        }
    },
   
}
</script>

<style lang="scss" scoped>
.main{
  padding-top:10px;
}
</style>